var map = {
	"./en/usmall.js": "FeGY",
	"./tw/usmall.js": "3v4D",
	"./zh/usmall.js": "Xwp3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a16M";


//////////////////
// WEBPACK FOOTER
// ./src/lang \/.*\/.*.js$
// module id = a16M
// module chunks = 112